module.exports = __webpack_public_path__ + "static/media/logo-png.5774823d.png";